<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Panel from './components/admin-panel/Panel.vue'

export default {
  name: 'App',
}
</script>